/*
    Copyright 2022-2026, Techwise Integrated Security, LLC
*/

import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../../app/store";
import { ServiceLocation, VersionedPagination } from "../../utils/Interfaces";

export interface SitesState {
    existingSites: ServiceLocation[];
    existingSitesCount: number;
    existingSitesLoaded: boolean;
    existingSitesVersion: string;
}

const initialState: SitesState = {
    existingSites: [],
    existingSitesCount: 0,
    existingSitesLoaded: false,
    existingSitesVersion: "",
};

export const workSitesSlice = createSlice({
    name: "sites",
    initialState,
    reducers: {
        setExistingSites: (state, action: PayloadAction<VersionedPagination<ServiceLocation>>) => {
            state.existingSites = action.payload.results;
            state.existingSitesCount = action.payload.count;
            state.existingSitesLoaded = true;
            state.existingSitesVersion = action.payload.version;
        },
    },
});

export const { setExistingSites } = workSitesSlice.actions;

export const selectExistingSites = (state: RootState) => state.sites.existingSites;
export const selectExistingSitesCount = (state: RootState) => state.sites.existingSitesCount;
export const selectExistingSitesLoaded = (state: RootState) => state.sites.existingSitesLoaded;
export const selectExistingSitesVersion = (state: RootState) => state.sites.existingSitesVersion;

export default workSitesSlice.reducer;
